<span> {{ text | date : 'dd-MMM-yyyy' }}</span>
